<template>
  <div v-if="title" class="bg-white text-black rounded-3xl px-3 py-1 flex items-center group hover:bg-black hover:text-white cursor-pointer transform transition duration-200">
    <span class="mr-2 font-medium">{{ title }}</span>
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
})
</script>
